module.exports = __webpack_public_path__ + "img/1. FREESTYLER, STAND,CLIPS, BONDING RING.jpg";